import { render, staticRenderFns } from "./SalesChartSection.vue?vue&type=template&id=233c53f1&scoped=true"
import script from "./SalesChartSection.vue?vue&type=script&lang=js"
export * from "./SalesChartSection.vue?vue&type=script&lang=js"
import style0 from "./SalesChartSection.vue?vue&type=style&index=0&id=233c53f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c53f1",
  null
  
)

export default component.exports